// Generated by CoffeeScript 2.7.0
var SectionBreak;

import Base from './base.js';

export default SectionBreak = (function() {
  class SectionBreak extends Base {};

  SectionBreak.prototype.availableLayouts = ['block'];

  return SectionBreak;

}).call(this);
